import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  DoCheck,
} from "@angular/core";

@Component({
  selector: "app-brands",
  templateUrl: "./brands.component.html",
  styleUrls: ["./brands.component.sass"],
})
export class BrandsComponent implements OnInit, DoCheck {
  // brands: string[] = ['all', 'Lenovo', 'Dell', 'Dell', 'Lg', 'Samsung'];
  // brands: any[]; // = ['all', 'Brand-1', 'Brand-2', 'Brand-3', 'Brand-4', 'Brand-5'];
  brands: any; //[] = []; //[] = JSON.parse(sessionStorage.getItem('brands'));

  @Output() brandChanged = new EventEmitter();
  constructor() {}

  ngOnInit() {
    // this.brands = JSON.parse(sessionStorage.getItem('brands'));
  }

  ngDoCheck() {
    this.brands = JSON.parse(sessionStorage.getItem("brands"));
  }
  ngAfterViewChecked() {}
  brendSelect(event) {
    //console.log('click');
    this.brandChanged.emit(event.value);
  }
}
